var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 20,
    viewBox: "0 0 61 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2379_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1012 7.82009C29.0812 9.48505 30.5043 10.4141 31.5763 10.9665C32.6777 11.5333 33.0477 11.8968 33.0433 12.4037C33.0351 13.1793 32.1647 13.5217 31.3503 13.535C29.9294 13.5583 29.1032 13.1293 28.4464 12.8049L27.9345 15.3377C28.5935 15.6588 29.8137 15.9389 31.0791 15.9512C34.0493 15.9512 35.9925 14.4007 36.003 11.9968C36.0146 8.94592 32.0124 8.77705 32.0398 7.41339C32.0492 6.9999 32.4223 6.55864 33.2399 6.44645C33.6446 6.38978 34.7617 6.3464 36.0283 6.96317L36.5254 4.51257C35.8443 4.25031 34.9688 3.99917 33.8789 3.99917C31.0833 3.99917 29.117 5.57074 29.1012 7.82009ZM41.3021 4.21026C40.7597 4.21026 40.3027 4.54481 40.0987 5.05821L35.8559 15.7712H38.8239L39.4145 14.0451H43.0414L43.384 15.7712H46L43.7172 4.21026H41.3021ZM41.7173 7.33329L42.5738 11.6745H40.228L41.7173 7.33329ZM25.5026 4.2104L23.163 15.771H25.9913L28.3298 4.21011L25.5026 4.2104ZM21.3186 4.2104L18.3747 12.0791L17.1839 5.38843C17.0442 4.64153 16.4924 4.21026 15.8796 4.21026H11.0674L11 4.54597C11.9879 4.77267 13.1104 5.1383 13.7904 5.52953C14.2066 5.76852 14.3253 5.97744 14.462 6.54534L16.7174 15.7712H19.7063L24.2885 4.21026L21.3186 4.2104Z",
    fill: "url(#paint0_linear_2379_1141)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2379_1141",
    x1: 1620.09,
    y1: 39.9269,
    x2: 1656.67,
    y2: -1187.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2379_1141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 12,
    fill: "white",
    transform: "translate(11 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d3554d6b7aad4cfb82d85b53b8a16758.svg";
export { ForwardRef as ReactComponent };